import React, { useState } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Table } from "react-bootstrap";
import moment from "moment";
import "moment-timezone";

import { api } from "../../../../api";
import { extractCenterId } from "../../../../utils/center";
import { isMissingQueueEnforced } from "../../../../utils/permissions";
import { DISPATCH_WAITING_PRODUCTS_ORDERED } from "../../actions";
import WaitingProductsRow from "./WaitingProductsRow";

import "../../../../css/WaitingProductsList.css";

const DAYS = [
  { value: 0, label: "Aujourd'hui" },
  { value: 1, label: "Demain" },
];

const shippingDay = (task) => moment(task.linked_order.shipping_time).tz("Europe/Paris").format("YYYY-MM-DD");

/**
 * Commandes en attente de produits du centre, sous « Commandes en retard ».
 * Les données arrivent avec /dispatch/loadstate (même rafraîchissement que
 * l'écran) ; le choix du jour ne fait que filtrer ce qui est déjà chargé.
 * Avec le droit dispatch, un interrupteur de priorité par ligne (aucune,
 * élevée, urgente). L'ordre affiché est celui des préparateurs.
 */
export const WaitingProductsList = ({ centerId, allTasks, canOrder, enforced, onOrdered }) => {
  const [dayOffset, setDayOffset] = useState(0);
  const [error, setError] = useState(false);

  const day = moment().tz("Europe/Paris").add(dayOffset, "days").format("YYYY-MM-DD");
  const tasks = allTasks.filter(t => shippingDay(t) === day);

  const [busy, setBusy] = useState(false);

  const onSetPriority = async (taskId, priority) => {
    setBusy(true);
    try {
      const dayKey = dayOffset === 0 ? "today" : "tomorrow";
      const sameDay = await api.setWaitingPriority(centerId, taskId, priority, dayKey);
      onOrdered(allTasks.filter(t => shippingDay(t) !== day).concat(sameDay));
      setError(false);
    } catch (e) {
      setError(true);
    }
    setBusy(false);
  };

  return (
    <div className="WaitingProductsList waiting-products-list">
      <h4>
        Commandes en attente de produits : {tasks.length ? tasks.length : "AUCUNE"}
        <span className="btn-group mx-3">
          {DAYS.map(d => (
            <button key={d.value} type="button"
              className={"btn btn-xs " + (dayOffset === d.value ? "btn-primary" : "btn-default")}
              onClick={() => setDayOffset(d.value)}
            >{d.label}</button>
          ))}
        </span>
        {error ? <small className="text-danger">La priorité n'a pas pu être enregistrée</small> : null}
      </h4>
      {tasks.length ? (
        <Table bordered size="sm" hover striped>
          <thead>
            <tr>
              <th>Commande</th>
              <th>Sacs</th>
              <th>Poids (kg)</th>
              <th>Zone</th>
              <th>Client</th>
              <th>Adresse</th>
              <th>Pris par</th>
              <th>Créneau</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map(task => (
              <WaitingProductsRow key={task.id} task={task} canOrder={canOrder} enforced={enforced} busy={busy}
                onSetPriority={onSetPriority}
              />
            ))}
          </tbody>
        </Table>
      ) : null}
    </div>
  );
};

WaitingProductsList.propTypes = {
  centerId: PropTypes.number,
  allTasks: PropTypes.array.isRequired,
  canOrder: PropTypes.bool,
  enforced: PropTypes.bool,
  onOrdered: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const groups = (state.user && state.user.groups) || {};
    return {
      centerId: extractCenterId(state.user),
      allTasks: state.dispatch.waiting_products || [],
      canOrder: !!groups.can_order_waiting_products,
      // priorité seulement là où l'ordre est imposé (Reuilly)
      enforced: isMissingQueueEnforced(state),
    };
  },
  (dispatch) => ({
    onOrdered: (tasks) => dispatch({ type: DISPATCH_WAITING_PRODUCTS_ORDERED, tasks }),
  })
)(WaitingProductsList);
